import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "novasite_cookie_consent_v1";

export default function CookieBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      if (!localStorage.getItem(STORAGE_KEY)) setOpen(true);
    }, 800);
    return () => clearTimeout(t);
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ts: Date.now(), level: "essential" }));
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
          data-testid="cookie-banner"
          className="fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:bottom-6 md:max-w-md z-[60]"
        >
          <div className="bg-white border border-zinc-200 rounded-3xl shadow-[0_24px_64px_rgba(0,0,0,0.12)] p-6 md:p-7">
            <div className="flex items-start gap-3">
              <div className="shrink-0 w-10 h-10 rounded-2xl bg-zinc-900 text-white flex items-center justify-center">
                <Cookie size={18} strokeWidth={1.5} />
              </div>
              <div className="flex-1">
                <div className="font-display text-base font-medium text-zinc-900">
                  Nur das Nötigste
                </div>
                <p className="mt-1.5 text-sm text-zinc-600 leading-relaxed">
                  Diese Website verwendet ausschließlich technisch notwendige Speicherung im Browser
                  (z. B. für den Admin-Bereich). Es werden <strong>keine</strong> Tracking-Cookies,
                  kein Google Analytics und keine Werbe-Pixel eingesetzt.
                </p>
                <div className="mt-4 flex flex-wrap items-center gap-3">
                  <button
                    data-testid="cookie-accept"
                    onClick={accept}
                    className="inline-flex items-center justify-center rounded-full bg-zinc-900 text-white text-sm font-medium px-5 py-2.5 hover:bg-zinc-800 transition-all hover:scale-[1.02]"
                  >
                    Verstanden
                  </button>
                  <Link
                    to="/datenschutz"
                    data-testid="cookie-datenschutz-link"
                    className="text-sm text-zinc-600 hover:text-zinc-900 underline underline-offset-4"
                  >
                    Datenschutz
                  </Link>
                </div>
              </div>
              <button
                data-testid="cookie-close"
                onClick={accept}
                aria-label="Schließen"
                className="shrink-0 w-8 h-8 rounded-full hover:bg-zinc-100 flex items-center justify-center text-zinc-500"
              >
                <X size={16} />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
